import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock, ChevronRight } from "lucide-react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export default function Services() {
  const [services, setServices] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
        <div className="max-w-2xl mb-10">
          <div className="text-xs font-mono uppercase tracking-widest text-sky-400 mb-3">Catálogo completo</div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white">Serviços de refrigeração automotiva</h1>
          <p className="mt-4 text-slate-300">Preços transparentes, garantia e técnico qualificado. Taxa de deslocamento somada apenas após aprovação.</p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {services.map((s) => (
            <Card key={s.service_id} className="bg-slate-900/50 border-slate-800 overflow-hidden group hover:border-sky-500/50 transition-all">
              {s.image_url && (
                <div className="h-44 overflow-hidden">
                  <img src={s.image_url} alt={s.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                </div>
              )}
              <CardContent className="p-5">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-lg font-bold text-white">{s.name}</h3>
                  <Badge className="bg-sky-500/15 text-sky-300 border-sky-500/30 font-mono">
                    <Clock className="w-3 h-3 mr-1" />{s.duration_minutes}min
                  </Badge>
                </div>
                <p className="text-sm text-slate-400 mb-5 min-h-[48px]">{s.description}</p>
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-xs text-slate-500 font-mono uppercase tracking-wider">A partir de</div>
                    <div className="text-2xl font-black text-sky-400 font-mono">R$ {Number(s.price).toFixed(2)}</div>
                  </div>
                  <Button
                    size="sm"
                    onClick={() => nav(`/agendar?service=${s.service_id}`)}
                    className="bg-sky-500 hover:bg-sky-400 text-slate-950 font-bold"
                    data-testid={`service-book-${s.service_id}`}
                  >
                    Agendar <ChevronRight className="w-4 h-4 ml-1" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
